import styled from 'styled-components'

export const EmailConfirmationStyled = styled.div`
  border-bottom: 1px solid #ccc;
  padding-bottom: 1rem;
`

export const EmailInput = styled.div`
  display: flex;

  .email-input {
    padding-right: 0.5rem;
  }

  .remove-icon {
    font-size: 2rem;
    margin-top: 3rem;
  }
`
